import { Component, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { NgForm, UntypedFormBuilder } from '@angular/forms'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { ErrorMessageModalComponent } from '../modals/error-message-modal/error-message-modal.component'
import { PopupMessageModalComponent } from '../modals/popup-message-modal/popup-message-modal.component'

import { SiteService } from '../../services/site.service'
import { MessageService } from '../../services/message.service'
import { TranslateService } from '@ngx-translate/core'
import { CustomerRequestsService } from '../../services/customer-requests.service'

@Component({
    selector: 'app-customer-intent',
    templateUrl: './customer-intent.component.html',
    styleUrls: ['./customer-intent.component.scss'],
    standalone: false
})
export class CustomerIntentComponent implements OnInit 
{
  	@ViewChild('customerIntentForm') public customerIntentForm: NgForm
	formSubmitted: boolean = false
	invalidForm: boolean = false

	currentLanguage: string = 'en'
	otherLanguage: string = 'Français'
	emailPattern = '^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,4}$'
	phonePattern = '^[0-9]{10,10}$'
	vinPattern = '^[a-zA-Z0-9]{17,17}$'
	leaseNumberPattern = '^[0-9]*$'
	isSubmitted = false;
	customer =
	{
		lastName: '',
		firstName: '',
		emailAddress: '',
		phoneNumber: '',
		leaseNumber: '',
		vin: '',
		leaseEndOption: '',
		otherOption: '',
		contacted: ''
	}

	constructor(
		private formBuilder: UntypedFormBuilder,
		public dialog: MatDialog,
		private siteService: SiteService,
		private messageService: MessageService,
		private translateService: TranslateService,
		private customerRequestsService: CustomerRequestsService
	) 
	{ 
	}

	ngOnInit() 
	{
	}

	resetClick()
	{
		this.formSubmitted = false
		this.isSubmitted = false

		this.customer =
		{
			lastName: '',
			firstName: '',
			emailAddress: '',
			phoneNumber: '',
			leaseNumber: '',
			vin: '',
			leaseEndOption: '',
			otherOption: '',
			contacted: ''
		}
	}
  
	saveCustomerIntent(customerIntentForm: NgForm)
	{
		this.formSubmitted = true

		this.validateForm()
		if (customerIntentForm.invalid || this.invalidForm == true)
		{
		return
		}

		this.messageService.startedHttpRequest('saveCustomerIntent')
		this.customerRequestsService
			.addCustomerIntent(this.customer)
			.subscribe({
				next: (apiResponse) =>
				{
					this.formSubmitted = false

					const dialogConfig = new MatDialogConfig()
					dialogConfig.width = '500px',
					dialogConfig.data = {
					title: this.translateService.instant('INTENT_FORM_TITLE'),
					message: this.translateService.instant('INTENT_FORM_SUBMIT_SUCCESS'),
					}

					this.dialog.open(PopupMessageModalComponent, dialogConfig)

					this.resetClick()
					this.isSubmitted = true		
				},
				error: (error) =>
				{
					this.messageService.completedHttpRequest('saveCustomerIntent')

					const dialogConfig = new MatDialogConfig()
					dialogConfig.width = '500px',
					dialogConfig.data = {
						title: this.translateService.instant('COMMON_LBL_ERROR'),
						message: this.translateService.instant('COMMON_LBL_ERROR_MSG'),
					}
					
					this.dialog.open(ErrorMessageModalComponent, dialogConfig)
				},
				complete: () =>
				{
					this.messageService.completedHttpRequest('saveCustomerIntent')
				}
			})
	}
  
	validateForm()
	{
		this.invalidForm = false

		if((this.customer.leaseNumber == '' && this.customer.vin == '') || 
			(this.customer.leaseEndOption=='Other' && this.customer.otherOption==''))
		{
			this.invalidForm = true
		}
	}

	phoneValidator(event: any) 
	{
		const pattern = /^[0-9]*$/;   
		if (!pattern.test(event.target.value)) 
		{
			event.target.value = event.target.value.replace(/[^0-9]/g, '')
			this.customer.phoneNumber = event.target.value
		}
	}

	leaseNumberValidator(event: any) 
	{
		const pattern = /^[0-9]*$/;   
		if (!pattern.test(event.target.value)) 
		{
			event.target.value = event.target.value.replace(/[^0-9]/g, '')
			this.customer.leaseNumber = event.target.value
		}
	}
}
